import React from 'react'
import { Ball, LoadingContainer } from './style'

export default function Loading() {
  return (
    <LoadingContainer>
      <Ball />
      <Ball />
      <Ball />
    </LoadingContainer>
  )
}
